import React from "react";
import "./Pricing.css";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer/Footer";

const Pricing = () => {
  return (
    <>
      <section id="pricing" className="pricing-section">
        <h2>Pricing</h2>
        <p className="pricing-intro">
          Lesson lengths and formats are below. Rates are shown where fixed; for
          services that vary, start an inquiry and we’ll tailor a quote.
        </p>

        <div className="pricing-grid">
          {/* 1:1 Lessons (monthly) */}
          <div className="price-card">
            <h3>1:1 Lessons (Monthly)</h3>
            <ul className="price-list">
              <li>
                <span>Piano</span>
                <span className="meta">$240/mo · 4×60m</span>
              </li>
              <li>
                <span>Guitar</span>
                <span className="meta">$240/mo · 4×60m</span>
              </li>
              <li>
                <span>Bass</span>
                <span className="meta">$240/mo · 4×60m</span>
              </li>
              <li>
                <span>Drums</span>
                <span className="meta">$240/mo · 4×45m</span>
              </li>
              <li>
                <span>Trumpet</span>
                <span className="meta">$240/mo · 4×45m</span>
              </li>
              <li>
                <span>Tracks &amp; Software</span>
                <span className="meta">
                  $240/mo · 4×60m (Logic Pro, Ableton, MainStage)
                </span>
              </li>
            </ul>
            <div className="cta-row">
              <Link to="/booking" className="btn-ghost">
                Book a Lesson
              </Link>
            </div>
          </div>

          {/* Audio Training */}
          <div className="price-card">
            <h3>Audio-Engineering Training</h3>
            <ul className="price-list">
              <li>
                <span>Live sound / DAW workflow</span>
                <span className="meta">$120/hr · 2-hr minimum</span>
              </li>
            </ul>
            <div className="cta-row">
              <Link to="/audio" className="btn-ghost">
                Request Audio Support
              </Link>
            </div>
          </div>

          {/* Event Audio / Services */}
          <div className="price-card">
            <h3>Event Audio</h3>
            <ul className="price-list">
              <li>
                <span>In-house mixing</span>
                <span className="meta">Typically $400+ · + travel</span>
              </li>
              <li>
                <span>Livestream mixing</span>
                <span className="meta">Typically $300+ · + travel</span>
              </li>
              <li>
                <span>In-person consultation</span>
                <span className="meta">$60/hr · + travel</span>
              </li>
              <li>
                <span>System setup &amp; tuning</span>
                <span className="meta">Varies · Quote</span>
              </li>
              <li>
                <span>Recording</span>
                <span className="meta">Varies · Quote</span>
              </li>
            </ul>
            <p className="note">
              Bay-Area based • Available on-site nationwide
            </p>
            <div className="cta-row">
              <Link to="/audio" className="btn-ghost">
                Start an Inquiry
              </Link>
            </div>
          </div>

          {/* Group Lessons */}
          <div className="price-card">
            <h3>Group Lessons</h3>
            <ul className="price-list">
              <li>
                <span>Piano</span>
                <span className="meta">$35/person</span>
              </li>
              <li>
                <span>Guitar</span>
                <span className="meta">$35/person</span>
              </li>
              <li>
                <span>Bass</span>
                <span className="meta">$35/person</span>
              </li>
              <li>
                <span>Trumpet</span>
                <span className="meta">$35/person</span>
              </li>
            </ul>
            <div className="cta-row">
              <Link to="/booking" className="btn-ghost">
                Ask About Group Availability
              </Link>
            </div>
          </div>
        </div>

        {/* Footer helper: FAQ anchor + Reach out button */}
        <p className="pricing-foot">
          Have questions? Visit the{" "}
          {/* Use a plain anchor so it jumps to the Home FAQ section */}
          <a href="/#faq">FAQ</a>.
        </p>
        <div className="cta-row">
          <Link to="/contact" className="btn-ghost">
            Reach out
          </Link>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Pricing;
